// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

//Third Party
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//Services
import { AuthGuard } from "../shared/services/authGuard"

//Components
import { CappComponent } from './components/capp';
import { CappMainComponent } from './components/cappMain';
import { CappNarrativeDashboardComponent } from './components/cappNarrativeDashboard';
import { CappEditComponent } from './components/cappEdit';
import { CappViewComponent } from './components/cappView';

//Modules
import { SharedModule } from '../shared/shared.module';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
export const CappRoutes = [
    {
        path: 'capp',
        component: CappComponent,
        children: [
            { path: '', redirectTo: 'main', pathMatch: 'full' },
            { path: 'main', component: CappMainComponent },
            { path: 'dashboard/:fy/:practiceStateId', component: CappNarrativeDashboardComponent },
            { path: 'edit/:fy/:practiceStateId/:narrativeId', component: CappEditComponent },
            { path: 'view/:fy/:practiceStateId/:narrativeId', component: CappViewComponent }
        ]
    }
];

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CppeModule
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@NgModule({
    imports: [
        NgbModule,
        RouterModule,
        SharedModule
    ],
    declarations: [
        CappComponent,
        CappMainComponent,
        CappEditComponent,
        CappViewComponent,
        CappNarrativeDashboardComponent
    ],
    providers: [AuthGuard],
    exports: []
})
export class CappModule { }
